"use client"

import { useState } from "react"
import toast from "react-hot-toast"
import { followOrUnfollowUser } from "@/app/actions"
import { Text } from "@/components/Text"

type PublicPageHeaderFollowerSectionProps = {
  userId: string
  followedBy: string[]
  isFollowing: boolean
  showFollowButton: boolean
}

const PublicPageHeaderFollowerSection = ({
  userId,
  followedBy,
  isFollowing,
  showFollowButton,
}: PublicPageHeaderFollowerSectionProps) => {
  const [loading, setLoading] = useState(false)

  const handleFollowAction = async () => {
    setLoading(true)
    const { success } = await followOrUnfollowUser(userId)
    if (success) {
      toast.success(isFollowing ? "Unfollowed" : "Followed")
    } else {
      toast.error("Something went wrong")
    }
    setLoading(false)
  }

  let buttonText

  if (isFollowing) {
    if (loading) {
      buttonText = "Unfollowing..."
    } else {
      buttonText = "Unfollow"
    }
  } else {
    if (loading) {
      buttonText = "Following..."
    } else {
      buttonText = "Follow"
    }
  }
  return (
    <div className="w-full max-w-xs flex flex-col items-center justify-center gap-2">
      <Text className="!text-zinc-200 shadow-md p-2 rounded-xl">
        <span className="font-bold">{followedBy.length}</span> follower
        {followedBy.length !== 1 && "s"}
      </Text>
      {showFollowButton && (
        <button
          onClick={handleFollowAction}
          disabled={loading}
          className={`text-white text-sm border-2 ${
            isFollowing
              ? "bg-zinc-700 border-zinc-500 hover:bg-zinc-800 hover:border-zinc-200"
              : "bg-blue-700 border-blue-500 hover:bg-blue-800 hover:border-blue-200"
          } w-full max-w-md disabled:bg-zinc-700 disabled:border-zinc-700 transition shadow-md p-2 rounded-xl`}
        >
          {buttonText}
        </button>
      )}
    </div>
  )
}

export default PublicPageHeaderFollowerSection
